import axiosInstance from '../../../lib/axios';

export const authService = {
  login: async (credentials) => {
    try {
      // Pas de CSRF pour les tokens
      const response = await axiosInstance.post('/api/v1/admin/login', credentials);

      if (response.data.token) {
        localStorage.setItem('token', response.data.token);
        // Configurer immédiatement Axios avec le nouveau token
        axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;
      }

      return response.data;
    } catch (error) {
      console.error('Erreur de login:', error);
      throw error;
    }
  },

  logout: async () => {
    try {
      await axiosInstance.post('/api/v1/admin/logout');
    } catch (error) {
      console.error('Erreur logout:', error);
    } finally {
      // Nettoyer même en cas d'erreur
      localStorage.removeItem('token');
      delete axiosInstance.defaults.headers.common['Authorization'];
    }
  },

  changePassword: async (data) => {
    const response = await axiosInstance.post('/api/v1/admin/update-password', data);
    return response.data;
  },

  getCurrentUser: async () => {
    const response = await axiosInstance.get('/api/v1/admin/me');
    return response.data;
  },

  // Vérifier si l'utilisateur est authentifié
  isAuthenticated: () => {
    return !!localStorage.getItem('token');
  },

  // Récupérer le token
  getToken: () => {
    return localStorage.getItem('token');
  }
};